import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-reset-confirmation',
  templateUrl: './auth-reset-confirmation.component.html',
  styleUrls: ['./auth-reset-confirmation.component.scss']
})
export class AuthResetConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
